import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import imageSrc from '../../assets/images/imagePiggy.png'
import { NavLink } from 'react-router-dom';
import { useGetPartnersListQuery } from '../../redux/api/common';
import PartnerItem from '../partnerItem';

export default React.memo(function PartnersEpicBlock({
                                                  children
                                                }) {
  const { t } = useTranslation('common');

  const { data: partnersList = [] } = useGetPartnersListQuery();
  const [hasSlider, setHasSlider] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setHasSliderByWidth();
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [partnersList]);

  const listData = useMemo(() => {
    const result = [];
    for (let i = 0; i <= 2; i++) {
      result.push(<li key={i}>{t(`descriptions.partners_${i}`)}</li>);
    }
    return result;
  }, [i18n.language]);

  const partnerCardWidth = 235;

  const setHasSliderByWidth =  useCallback(() => {
    setHasSlider(window.innerWidth / partnerCardWidth < partnersList.length)
  },[partnersList]);

  const partners = useMemo(() => {
    const  items = hasSlider ? [...partnersList, ...partnersList]: partnersList;
    return items.map((item, index) => (
      <PartnerItem key={item.id + `${index}`} partnerData={item} linkActive={false}
                   className={' border rounded-lg overflow-hidden opacity-50 hover:opacity-100'}
                   classNamesImg={`w-[${partnerCardWidth}px] h-[98px] py-8 px-10 border rounded-lg flex items-center justify-center`} />
    ));
  }, [partnersList, partnerCardWidth, hasSlider]);

  return (<>
      <div className={'pt-20  overflow-hidden'}>
        <div className={'grid grid-cols-1 md:grid-cols-7 w-full bg-brandedColor-ORANGE'}>
          <div className={'w-full col-span-4 py-20 pl-24 pr-0'}>

            <div className="mb-4 text-[36px] md:text-[56px] font-medium tracking-tight leading-[1.16] text-black">
              <span>{t('titles.partners_epic')}</span></div>
            <p className="text-black pb-4 text-xl font-normal leading-normal">{t('descriptions.partners_main')}</p>
            <ul className="list-disc pl-6 pb-10 text-xl font-normal leading-normal">
              {listData}
            </ul>
            <div className={'flex'}>
              <NavLink to={'/contacts'} className={'block text-white'}>
                  <span
                    className={'block py-[10px] px-[15px] bg-white text-base overflow-hidden rounded-lg '}>
                    <span className={'relative text-black z-[1] select-none'}>
                      {t('buttons.become_partner')}
                    </span>
                  </span>
              </NavLink>
            </div>

          </div>
          <div className={'relative w-full col-span-3 min-h-[300px]'}>
            <img src={imageSrc}
                 className={' absolute scale-[1.5] sm:scale-110 md:scale-[2] lg:scale-150 top-1/4 sm:-top-6 -left-8 md:top-1/4 lg:top-16 transform md:translate-y-10 lg:translate-y-16'}
                 alt={'game character'} />
          </div>

        </div>
      </div>
      <div className={'flex items-center flex-col w-full mt-14'}>
        <div className={'w-full md:flex md:flex-col md:items-center'}> {/*contents*/}
          <div className="mb-4 text-base font-normal tracking-tight leading-[1.16] text-black/70">
            <span>{t('titles.partners')}</span></div>
        </div>
        <div className="overflow-hidden w-full bg-white">
          <div
            className={`flex gap-4 items-center justify-center ${hasSlider ? 'w-max animate-slideLeft' : 'animate-none w-full'}`}
            style={{ animationDuration: `${10}s` }}>
            {partners}
          </div>
        </div>
      </div>


    </>
  );
})
